module.exports = __webpack_public_path__ + "static/media/iconValores1.56164b7c.svg";